var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings", {
    staticClass: "column-content-settings button-settings",
    attrs: {
      title: _vm.resource("TemplateColumnButtonSettings_Settings_Title"),
      region: "right"
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("settings-slider", {
              attrs: {
                label: _vm.resource(
                  "TemplateColumnButtonSettings_ContainerHeight_Label"
                ),
                "value-suffix": "px",
                min: 1,
                max: 250
              },
              model: {
                value: _vm.model.style.containerHeight,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "containerHeight", $$v)
                },
                expression: "model.style.containerHeight"
              }
            }),
            _vm._v(" "),
            _c("settings-slider", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Width_Label"),
                "value-suffix": "%"
              },
              model: {
                value: _vm.model.style.width,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "width", $$v)
                },
                expression: "model.style.width"
              }
            }),
            _vm._v(" "),
            _c("settings-slider", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Height_Label"),
                "value-suffix": "%"
              },
              model: {
                value: _vm.model.style.height,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "height", $$v)
                },
                expression: "model.style.height"
              }
            }),
            _vm._v(" "),
            _c("settings-color-picker", {
              attrs: {
                label: _vm.resource(
                  "TemplateManager_Shared_BackgroundColor_Label"
                )
              },
              model: {
                value: _vm.model.style.backgroundColor,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "backgroundColor", $$v)
                },
                expression: "model.style.backgroundColor"
              }
            }),
            _vm._v(" "),
            _c("settings-color-picker", {
              attrs: {
                label: _vm.resource(
                  "TemplateColumnButtonSettings_BorderColor_Label"
                )
              },
              model: {
                value: _vm.model.style.borderColor,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "borderColor", $$v)
                },
                expression: "model.style.borderColor"
              }
            }),
            _vm._v(" "),
            _c("settings-textbox", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Link_Label")
              },
              model: {
                value: _vm.model.link,
                callback: function($$v) {
                  _vm.$set(_vm.model, "link", $$v)
                },
                expression: "model.link"
              }
            }),
            _vm._v(" "),
            _c("settings-slider", {
              attrs: {
                label: _vm.resource(
                  "TemplateColumnButtonSettings_BorderRadius_Label"
                ),
                "value-suffix": "px",
                min: 0,
                max: 30
              },
              model: {
                value: _vm.model.style.borderRadius,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "borderRadius", $$v)
                },
                expression: "model.style.borderRadius"
              }
            }),
            _vm._v(" "),
            _c("settings-position", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Position_Label")
              },
              model: {
                value: _vm.model.style.position,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "position", $$v)
                },
                expression: "model.style.position"
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }